import { Text } from "@/components/ui/baseUi/text"
import { UserFinancesPageHeader } from "@/modules/finances/components/financesPageHeader"
import { cn } from "@/modules/lib/utils"
import { Path } from "@/modules/navigation/routes"
import { StripeAccountStatus } from "@/modules/payment/stripeTypes"
import { LoadingSpinner } from "@/modules/ui/components/loading"
import { useUser } from "@/modules/users/hooks/useUser"
import errorNoRepLight from "@images/error/errorNoRepLight.svg"
import { word } from "@modules/core/utils/i18n"
import { StripeStatusBanner } from "@modules/finances/components/stripeStatusBanner"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { Outlet, useLocation } from "react-router-dom"

export const UserFinancesPage: React.FC = () => {
  const user = useUser()

  const isStripeAccountComplete = user.stripeAccountStatus === StripeAccountStatus.OK
  const { pathname } = useLocation()
  const isPayoutsPage = pathname.includes(Path.MySpace.Finances.Payouts)
  const isPromoCodesPage = pathname.includes(Path.MySpace.Finances.PromoCodes)
  const isPaymentsToValidatePage = pathname.includes(Path.MySpace.Finances.PaymentsToValidate)
  const isPayinsPage = !isPayoutsPage && !isPromoCodesPage && !isPaymentsToValidatePage

  if (!isStripeAccountComplete)
    return (
      <div className="flex w-full grow flex-col p-6">
        <UserFinancesPageHeader
          pageName={word("menu.finances")}
          displayMonthPicker={false}
          displaySettingsButton={false}
        />
        <div className="flex">
          <StripeStatusBanner />
        </div>
      </div>
    )
  else
    return (
      <div className="flex w-full grow flex-col p-6">
        <UserFinancesPageHeader
          pageName={word("menu.finances")}
          subPageName={
            isPayoutsPage
              ? word("finances.page.payouts.title")
              : isPromoCodesPage
                ? word("finances.page.promoCodes.title")
                : isPaymentsToValidatePage
                  ? word("finances.page.paymentToValidate.title")
                  : undefined
          }
          displayMonthPicker={isPayinsPage}
          displaySettingsButton={isPayinsPage}
        />

        <Suspense fallback={<LoadingSpinner />}>
          <ErrorBoundary fallback={<UserFinanceErrorView />}>
            <Outlet />
          </ErrorBoundary>
        </Suspense>
      </div>
    )
}

export function UserFinanceErrorView({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div className={cn("flex h-80 min-h-full w-full flex-col items-center justify-center gap-2", className)} {...props}>
      <Text fontStyle="BM" className="text-textDefault-body">
        {word("global.error.norep")}
      </Text>
      <img src={errorNoRepLight} />
      <Text fontStyle="BM" className="text-textDefault-caption">
        {word("global.error.somethingGoneWrong")}
      </Text>
    </div>
  )
}
